var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-fallthrough */
import debug from "debug";
import { AUVIOUS_VALID_URL_REGEX, ErrorCode, WIDGET_COBROWSE_REQUEST_PREFIX, } from "./models";
import { codeError } from "./utils";
const log = debug("auvious:integrations");
class EventServiceCtr {
    constructor() {
        this.closeFromError = false;
    }
    init(conversationService, streamUri, handlers, options) {
        var _a, _b;
        this.handlers = handlers;
        this.conversationServiceInstance = conversationService;
        if (options === null || options === void 0 ? void 0 : options.customDomain) {
            this.customDomain = new RegExp(
            // escape any special characters in the stringToFind to prevent them from being interpreted as regex operators.
            options.customDomain.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i");
        }
        try {
            (_b = (_a = this.handlers) === null || _a === void 0 ? void 0 : _a.connecting) === null || _b === void 0 ? void 0 : _b.call(_a);
            this.ws = new WebSocket(streamUri);
            this.ws.onopen = () => {
                var _a, _b;
                (_b = (_a = this.handlers).connected) === null || _b === void 0 ? void 0 : _b.call(_a);
            };
            this.ws.onclose = () => {
                var _a, _b;
                if (this.closeFromError) {
                    this.closeFromError = false;
                    log("websocket trying to reconnect...");
                    setTimeout(() => this.init(conversationService, streamUri, handlers), 1000);
                }
                else {
                    (_b = (_a = this.handlers).disconnected) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
            };
            this.ws.onerror = (event) => {
                this.closeFromError = true;
                this.ws.close();
                this.handlers.error(codeError(new Error(`websocket.onerror:${event.type}`), ErrorCode.GENESYS_API_ERROR));
            };
            this.ws.onmessage = this.onMessage.bind(this);
        }
        catch (ex) {
            this.handlers.error(codeError(ex, ErrorCode.GENESYS_API_ERROR));
        }
    }
    onMessage(message) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const messageData = JSON.parse(message.data);
                // ignore websocket heartbeat messages
                if (messageData.topicName === "channel.metadata") {
                    return;
                }
                switch (messageData.metadata.type) {
                    case "typing-indicator": {
                        const memberT = yield this.conversationServiceInstance.getMemberInfo(messageData.eventBody.conversation.id, messageData.eventBody.sender.id);
                        if ((memberT === null || memberT === void 0 ? void 0 : memberT.role) === "AGENT") {
                            (_b = (_a = this.handlers).agentTypingStarted) === null || _b === void 0 ? void 0 : _b.call(_a);
                        }
                        break;
                    }
                    // A participant state has changed
                    case "member-change":
                        this.handleMemberChangeEvent(messageData);
                        break;
                    case "message":
                        this.handleMessageEvent(messageData);
                        break;
                }
            }
            catch (ex) {
                this.handlers.error(codeError(ex, ErrorCode.GENESYS_API_ERROR));
            }
        });
    }
    handleMemberChangeEvent(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function* () {
            const member = yield this.conversationServiceInstance.getMemberInfo(data.eventBody.conversation.id, data.eventBody.member.id);
            switch (data.eventBody.member.state) {
                case "ALERTING":
                    log("agent notified", member);
                    this.handlers.agentNotified && this.handlers.agentNotified();
                    break;
                case "CONNECTED":
                    if ((member === null || member === void 0 ? void 0 : member.role) === "AGENT") {
                        log("agent joined", member);
                        (_b = (_a = this.handlers).agentJoined) === null || _b === void 0 ? void 0 : _b.call(_a, member);
                        break;
                    }
                    break;
                // agent ended interaction
                case "DISCONNECTED":
                    switch (member === null || member === void 0 ? void 0 : member.role) {
                        case "AGENT":
                            log("agent left", member);
                            (_d = (_c = this.handlers).agentLeft) === null || _d === void 0 ? void 0 : _d.call(_c);
                            break;
                        case "CUSTOMER":
                            log("customer left", member);
                            (_f = (_e = this.handlers).customerLeft) === null || _f === void 0 ? void 0 : _f.call(_e);
                            (_h = (_g = this.handlers).ended) === null || _h === void 0 ? void 0 : _h.call(_g);
                            break;
                    }
                    break;
            }
        });
    }
    handleMessageEvent(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function* () {
            const memberN = yield this.conversationServiceInstance.getMemberInfo(data.eventBody.conversation.id, data.eventBody.sender.id);
            if (!memberN) {
                return;
            }
            switch (data.eventBody.bodyType) {
                // A new participant has joined the PureCloud chat conversation
                case "member-join":
                // A participant has left the PureCloud chat conversation
                case "member-leave":
                    break;
                case "standard": {
                    const isLocal = memberN.role === "CUSTOMER";
                    const message = {
                        isLocal,
                        senderId: memberN.id,
                        text: data.eventBody.body,
                        type: "text",
                        id: data.eventBody.id,
                        timestamp: new Date(data.eventBody.timestamp),
                        status: "ack",
                    };
                    log("message received", message);
                    if (!isLocal) {
                        (_b = (_a = this.handlers).agentTypingStopped) === null || _b === void 0 ? void 0 : _b.call(_a);
                    }
                    (_d = (_c = this.handlers).messageReceived) === null || _d === void 0 ? void 0 : _d.call(_c, message);
                    break;
                }
                // a notice from the agent holds the ticket
                case "notice":
                    if (memberN.role === "AGENT") {
                        if (AUVIOUS_VALID_URL_REGEX.test(data.eventBody.body) ||
                            ((_e = this.customDomain) === null || _e === void 0 ? void 0 : _e.test(data.eventBody.body))) {
                            log("room created", data.eventBody.body);
                            (_g = (_f = this.handlers).roomCreated) === null || _g === void 0 ? void 0 : _g.call(_f, data.eventBody.body);
                        }
                        else if (data.eventBody.body.indexOf(WIDGET_COBROWSE_REQUEST_PREFIX) > -1) {
                            log("CXOne: cobrowse requested", data.eventBody.body);
                            // auvious:cobrowse-request:<request-type>:<ticket>
                            const request = data.eventBody.body.split(":");
                            const requestType = request[2];
                            const ticket = request[3];
                            (_j = (_h = this.handlers).cobrowseRequested) === null || _j === void 0 ? void 0 : _j.call(_h, ticket, requestType);
                        }
                    }
                    break;
            }
        });
    }
    destroy() {
        var _a;
        (_a = this.ws) === null || _a === void 0 ? void 0 : _a.close();
    }
}
export const EventService = new EventServiceCtr();
